import {createAction, props} from '@ngrx/store';
import {ReportViewState } from './report-view.model';
import { ReportViewPerspective, ReportViewResponse } from '../../models/report-view.models';

export const initializeReportView = createAction(
    '[Report View Component] Initialize Report View',
    props<{config: ReportViewResponse}>()
    );

export const initializeReportViewSuccess = createAction(
    '[Report View Effects] Initialize Report View Success',
    props<{reportName: string, reportViewState: ReportViewState}>()
    );

export const selectPerspective = createAction(
    '[Perspective Selector Component] Select Perspective',
    props<{reportName: string, perspective: ReportViewPerspective}>()
    );
